import { render, staticRenderFns } from "./CompareTableBtn.vue?vue&type=template&id=ef2851e6"
import script from "./CompareTableBtn.vue?vue&type=script&lang=js"
export * from "./CompareTableBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports